import { Field, FieldProps } from 'formik';
import { SwitchComponent } from '../Switch';

interface FormikSwitchProps {
  name: string;
  label?: string;
  falseLabel?: string;
  required?: boolean;
  disabled?: boolean;
}

export const FormikSwitch: React.FC<FormikSwitchProps> = ({
  name,
  label,
  falseLabel,
  required,
  disabled
}) => {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => (
        <SwitchComponent
          checked={field.value}
          onChange={value => form.setFieldValue(name, value)}
          disabled={disabled}
          label={label}
          falseLabel={falseLabel}
          required={required}
          name={name}
        />
      )}
    </Field>
  );
};
